import { List, Typography } from '@mui/material';

const generateIdsAndValues = (values: string[]) => {
    return values.map((value, index) => ({
        id: `item-${index}`,
        value: value
    }));
};

type ReportInfoListTemplateProps = {
    title: string;
    values: string[];
}

export const ReportInfoListTemplate = ({
    title,
    values
}: ReportInfoListTemplateProps) => {
    return (
        <>
            <Typography
                variant='subtitle1'
                color='primary.accent'
                component='div'
            >
                {title}:
            </Typography>
            <List>
                {generateIdsAndValues(values).map((headerValue) => (
                    <div key={headerValue.id}>
                        <Typography
                            component='div'
                            variant='subtitle1'
                            gutterBottom
                        >
                            {headerValue.value}
                        </Typography>
                    </div>
                ))}
            </List>
        </>
    );
};
